import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de planes económicos (HU-17). Backend: `UNICEN/modules/economico`.
// Contrato completo: UNICEN/modules/economico/docs/planes-economicos.openapi.yaml
//
// Token obligatorio, `{ data }`, errores `{ mensaje, campo? }` (leer con `errorDeApi`).
//
//   GET  /economico/planes-economicos?buscar&estado=TODOS|ACTIVO|INACTIVO&nuevos=TODOS|SI|NO
//        &orden=estado|nombre|ultimo_cambio&direccion=asc|desc&pagina&limite
//        -> { planes: [Plan], total, pagina, limite }
//   GET  /economico/planes-economicos/tipos              -> [{ id_tipo, nombre }]
//   GET  /economico/planes-economicos/estado-configuracion?id_gestion&id_sede
//        -> { gestion, id_sede, planes: [{ id_plan, grupos, grupos_sin_carreras, celdas,
//             celdas_sin_precio, estado: 'COMPLETO'|'INCOMPLETO'|'SIN_COBROS' }] }
//        DAF recibe solo los planes y grupos con carreras de su sede (lo decide el servidor).
//   GET  /economico/planes-economicos/:id_plan?id_sede   -> Plan + { historial: [Cambio] }
//   POST /economico/planes-economicos { nombre, detalle, codigo, id_tipo, disponible_nuevos } -> 201 Plan
//   PUT  /economico/planes-economicos/:id_plan?id_sede  (mismo cuerpo) -> Plan
//   POST /economico/planes-economicos/:id_plan/desactivacion | /reactivacion ?id_sede -> Plan
//        409 NombreDuplicado (campo: nombre), sin cambios, plan inactivo (campo: disponible_nuevos).
//
//   Plan: { id_plan, id_sede, codigo, nombre, detalle, id_tipo, tipo,
//           estado: 'ACTIVO'|'INACTIVO', disponible_nuevos, ultimo_cambio }
//
// `id_sede` identifica la fila (la tabla legada repite ids entre sedes): se
// manda de vuelta tal como vino en el listado y no se muestra.

const resource = '/economico/planes-economicos';

function deLaFila(plan) {
  return conToken({ params: { id_sede: plan.id_sede } });
}

function cuerpo({ nombre, detalle, codigo, id_tipo, disponible_nuevos }) {
  return { nombre, detalle, codigo, id_tipo, disponible_nuevos };
}

const usePlanesEconomicosApi = {
  listar({ buscar, estado, nuevos, orden, direccion, pagina, limite } = {}) {
    return apiClient.get(resource, conToken({
      params: { buscar, estado, nuevos, orden, direccion, pagina, limite },
    }));
  },

  estadoConfiguracion(idGestion, { idSede } = {}) {
    return apiClient.get(`${resource}/estado-configuracion`, conToken({
      params: { id_gestion: idGestion, ...(idSede ? { id_sede: idSede } : {}) },
    }));
  },

  tipos() {
    return apiClient.get(`${resource}/tipos`, conToken());
  },

  detalle(plan) {
    return apiClient.get(`${resource}/${plan.id_plan}`, deLaFila(plan));
  },

  crear(datos) {
    return apiClient.post(resource, cuerpo(datos), conToken());
  },

  editar(plan, datos) {
    return apiClient.put(`${resource}/${plan.id_plan}`, cuerpo(datos), deLaFila(plan));
  },

  desactivar(plan) {
    return apiClient.post(`${resource}/${plan.id_plan}/desactivacion`, {}, deLaFila(plan));
  },

  reactivar(plan) {
    return apiClient.post(`${resource}/${plan.id_plan}/reactivacion`, {}, deLaFila(plan));
  },
};

export default usePlanesEconomicosApi;
